module.exports = __webpack_public_path__ + "img/electronic_electric_no_zone.5a12323a.svg";